import { useSelector } from "react-redux";

const UseDistributionPermissions = () => {
  // Add defensive checks to prevent undefined errors
  const permissions = useSelector(
    (state) => state.projectReducer?.permissions
  ) || {};
  
  const distribution = permissions.distribution || {};

  // Default to true if permissions are not available
  let canView = distribution?.view ?? true;
  let canEdit = distribution?.add_edit ?? true;
  let canDelete = distribution?.delete ?? true;

  return [canView, canEdit, canDelete];
};

export default UseDistributionPermissions;
